/**
 * Shared helpers for feature route declarations.
 *
 * Every feature entry (`features/<x>/index.tsx`) is imported **statically** by
 * `registry.tsx` so that nav items are available synchronously at first paint.
 * That makes it essential that feature entries stay dependency-light: they must
 * reference their pages via `lazy()` factories only, never static imports, or
 * the whole feature graph lands in the entry chunk.
 *
 * `lazyRoute` supplies the required Suspense boundary with a skeleton fallback
 * (per `.claude/rules/loading-skeletons.md` — a lazy route body must never fall
 * back to bare text or a lone spinner).
 */
import { Suspense, type ReactNode } from 'react'
import { TabContentSkeleton } from '@/components/composites'

export function lazyRoute(node: ReactNode): JSX.Element {
  return <Suspense fallback={<TabContentSkeleton />}>{node}</Suspense>
}
